/* eslint-disable no-self-compare */
function is( x, y ) {


    if ( x === y ) {

        return x !== 0 || y !== 0 || 1 / x === 1 / y

    } else {

        return x !== x && y !== y

    }


}
const hasOwn = Object.prototype.hasOwnProperty;


export function shallowEqual( objA, objB ) {


    if ( is( objA, objB ) ) return true

    if (
        typeof objA !== 'object' ||
        objA === null ||
        typeof objB !== 'object' ||
        objB === null
    ) {
        return false
    }

    const keysA = Object.keys( objA )
    const keysB = Object.keys( objB )

    if ( keysA.length !== keysB.length ) return false

    for ( let i = 0; i < keysA.length; i++ ) {

        if ( !hasOwn.call( objB, keysA[i] ) || !is( objA[keysA[i]], objB[keysA[i]] ) ) {
            return false
        }

    }

    return true


}


export const getType = ( type ) => {
    return Object.prototype.toString.call( type );
};

export const isFunc = ( type ) => getType( type ) === "[object Function]";


export const getID = ( entity, prop ) => {
    const match = entity[prop] || entity?._links[prop]?.href;

    if ( !match ) return null;

    if ( match.indexOf( "http" ) >= 0 ) {

        const strArray = match.split( "/" );
        return strArray[strArray.length - 1];

    }
}

export const isEmptyObject = (obj)=>{
    return Object.keys(obj).length === 0;
}
